import React from 'react';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import { RISK_COMPLIANCE_BLOCK_STATUS } from '../../dataHandlers/riskComplianceConstants';
import DnBDataCard, { DnBFieldRow } from './DnBDataCard';

export default function CoreCompanyInfoCard({
  block,
  labels,
  emptyMessage,
  unavailableMessage,
  noDataMessage,
  fetchLabel,
  onFetch,
  onRefresh,
  isFetching,
}) {
  const data = block?.data;

  return (
    <DnBDataCard
      title={labels.title}
      icon={<CorporateFareOutlinedIcon fontSize="small" color="action" />}
      blockStatus={block?.status || RISK_COMPLIANCE_BLOCK_STATUS.EMPTY}
      emptyMessage={emptyMessage}
      unavailableMessage={unavailableMessage}
      noDataMessage={noDataMessage}
      fetchLabel={fetchLabel}
      onFetch={onFetch}
      onRefresh={onRefresh}
      isFetching={isFetching}
    >
      <DnBFieldRow label={labels.legalName} value={data?.legalName} />
      <DnBFieldRow label={labels.dunsNumber} value={data?.dunsNumber} />
      <DnBFieldRow label={labels.registeredAddress} value={data?.registeredAddress} />
      <DnBFieldRow label={labels.primaryIndustry} value={data?.primaryIndustry} />
      <DnBFieldRow label={labels.operatingStatus} value={data?.operatingStatus} />
      <DnBFieldRow label={labels.tradeStyle} value={data?.tradeStyle} />
      <DnBFieldRow
        label={labels.registrationNumbers}
        value={
          data?.registrationNumbers?.length
            ? data.registrationNumbers.map((reg) => `${reg.number}${reg.type ? ` (${reg.type})` : ''}`).join('; ')
            : undefined
        }
      />
      <DnBFieldRow label={labels.website} value={data?.website} />
      <DnBFieldRow label={labels.phone} value={data?.phone} />
      <DnBFieldRow label={labels.email} value={data?.email} />
    </DnBDataCard>
  );
}
